import { render, staticRenderFns } from "./PurpleHexContainer.vue?vue&type=template&id=1cd1a966&scoped=true"
var script = {}
import style0 from "./PurpleHexContainer.vue?vue&type=style&index=0&id=1cd1a966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1a966",
  null
  
)

export default component.exports